import React from 'react';
import Grid from '@material-ui/core/Grid';
import {useTranslation} from 'react-i18next';

export const HomePage = ({digitalProfileSettings}) => {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    const admissionAlgorithm = currentLang === 'en' && digitalProfileSettings.admission_algorithm_en ?
        digitalProfileSettings.admission_algorithm_en
        : digitalProfileSettings.admission_algorithm;
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <div dangerouslySetInnerHTML={{ __html: admissionAlgorithm }} />
            </Grid>
        </Grid>
    );
};
export default HomePage;